export default {"src":"/customer-services/_next/static/media/camera.d37debf9.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};